import All from "./all";
import Form from "./form";
import Scroll from "./scroll";

export default { All, Form, Scroll };
